import { always, ifElse, is } from 'ramda';

import { hasValue } from './value-checkers';

export const isString = is(String);

type ToString = (value?: any) => string;
export const toString: ToString = ifElse(hasValue, String, always(''));
